let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kfXhT"), load("2Lfdl"), load("cM9em"), load("fr9NE"), load("4A1p8")]).then(() => parcelRequire('2azQI'));